
declare global {
    interface Settings {
        VUE_APP_BASE_URL: string;
        VUE_APP_APP_NAME: string;
        VUE_APP_API_VERSION: string;
        VUE_APP_APP_ID: string;
        VUE_APP_EXTRA_PERMISSIONS: string;
        VUE_APP_TRANSLATION_SECTION: string;
        VUE_APP_CUSTOM_SETTING: string;
        VUE_APP_API_ADDRESS: string;
    }

    interface Window  {
        CustomSettings: Settings;
    }
}


const settings: Settings = window.CustomSettings || {};

const data = {
    VUE_APP_BASE_URL :  settings.VUE_APP_BASE_URL || process.env.VUE_APP_BASE_URL,
    VUE_APP_APP_NAME :  settings.VUE_APP_APP_NAME || process.env.VUE_APP_APP_NAME,
    VUE_APP_API_VERSION :  settings.VUE_APP_API_VERSION || process.env.VUE_APP_API_VERSION,
    VUE_APP_APP_ID :  settings.VUE_APP_APP_ID || process.env.VUE_APP_APP_ID,
    VUE_APP_EXTRA_PERMISSIONS :  settings.VUE_APP_EXTRA_PERMISSIONS || process.env.VUE_APP_EXTRA_PERMISSIONS,
    VUE_APP_TRANSLATION_SECTION :  settings.VUE_APP_TRANSLATION_SECTION || process.env.VUE_APP_TRANSLATION_SECTION,
    VUE_APP_API_ADDRESS : settings.VUE_APP_API_ADDRESS || process.env.VUE_APP_API_ADDRESS,
};

if (process.env.VUE_APP_CUSTOM_SETTING) {
    console.debug('Dev custom settings: ', data);
}

export default data;
